import { jsx as _jsx } from "react/jsx-runtime";
import { HLSPlaybackMode } from '@aws-sdk/client-kinesis-video-archived-media';
import { NodeEdgeMapper } from '@iotv/datamodel-core';
import { Button, Stack } from '@mui/material';
import { useContext, useReducer } from 'react';
import { v4 } from 'uuid';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { getPulseSX } from '../../../../cosmetics/sx';
import { DeviceControlDAO } from '../../../../data/DeviceControlDAO/DeviceControlDAO';
import { Severity } from '../../../../types';
import { KinesisVideoStreamContext } from '../../Context/KinesisVideoStreamContext';
const defaultState = {
    requesting: false,
};
const VideoStreamRequestControlsReducer = (prev, next) => ({ ...prev, ...next });
export const VideoStreamRequestControls = (props) => {
    const { recordedVideoIsRequesable } = props;
    const [localState, localDispatch] = useReducer(VideoStreamRequestControlsReducer, defaultState);
    const { state, dispatch } = useContext(KinesisVideoStreamContext);
    const [{ UserFunctions }, appMainDispatch] = useContext(AppMainViewContext);
    const { VideoStream, VideoHub, selectedHLSPlaybackMode } = state;
    const requestVideoStream = async (recentRecordedPeriod) => {
        if (!VideoStream || !VideoHub) {
            console.error('Error: VideoStream or VideoHub is undefined');
            localDispatch({ requesting: false });
            return;
        }
        localDispatch({ requesting: true });
        const nodeEdgeMapper = new NodeEdgeMapper();
        nodeEdgeMapper.loadItems([VideoStream, VideoHub]);
        const { err, data } = await DeviceControlDAO.video.control.requestStreaming({ videoStream: VideoStream, recentRecordedPeriod });
        if (err) {
            console.error('Error requesting video stream:', err);
            UserFunctions.setUserMessage({ content: `Error requesting video stream: ${err.message}`, severity: Severity.error, id: v4(), label: '', type: 'MessageBar' });
        }
        else if (data) {
            console.log('Video stream requested successfully:', data);
            UserFunctions.setUserMessage({ content: `Live Video stream requested successfully`, severity: Severity.success, id: v4(), label: '', type: 'SnackBar' });
        }
        localDispatch({ requesting: false });
    };
    const RequestVideoStreamControl = (_jsx(Stack, { direction: "column", spacing: 2, sx: { width: '100%' }, children: _jsx(Stack, { direction: "row", spacing: 2, sx: { width: '100%' }, children: _jsx(Button, { sx: localState.requesting ? getPulseSX({ animationDuration: 1 }) : {}, variant: "contained", color: VideoStream?.SiteWiseAssetIdForCamera ? 'inherit' : 'primary', disabled: localState.requesting, onClick: () => {
                    requestVideoStream();
                }, children: 'Request Live Stream' }) }) }));
    const RequestRecentVideoStreamControl = (_jsx(Stack, { direction: "column", spacing: 2, sx: { width: '100%' }, children: _jsx(Stack, { direction: "row", spacing: 2, sx: { width: '100%' }, children: _jsx(Button, { sx: localState.requesting ? getPulseSX({ animationDuration: 1 }) : {}, variant: "contained", color: VideoStream?.SiteWiseAssetIdForCamera ? 'inherit' : 'primary', disabled: localState.requesting, onClick: () => {
                    requestVideoStream({ fromTimestamp: Date.now() - 30 * 60 * 1000, toTimestamp: Date.now() });
                }, children: "Request Recent Video Stream" }) }) }));
    return (_jsx(Stack, { direction: "column", spacing: 2, sx: { width: '100%' }, children: selectedHLSPlaybackMode === HLSPlaybackMode.LIVE ? RequestVideoStreamControl : recordedVideoIsRequesable ? RequestRecentVideoStreamControl : null }));
};
